import React from "react";
import { Link } from "react-router-dom";
import { PendingChoice } from "@/components/vg2/AbbiamoCapitoCard";
import { LS_ANON } from "@/lib/vg2AnonAxios";
import { listPendingRequests, structuredRequestEnabled } from "@/lib/vg3StructuredRequest";

export function HomePendingRequests() {
  const [items, setItems] = React.useState([]);
  const [tick, setTick] = React.useState(0);
  React.useEffect(() => {
    (async () => {
      if (!localStorage.getItem(LS_ANON) && !localStorage.getItem("vg2_token")) return;
      if (!(await structuredRequestEnabled())) return;
      try { setItems(await listPendingRequests()); } catch { setItems([]); }
    })();
  }, [tick]);
  if (!items.length) return null;
  return (
    <div className="mb-8 space-y-4" data-testid="home-pending-requests">
      <p className="text-sm font-semibold" data-testid="home-pending-title">
        Hai {items.length === 1 ? "una richiesta" : `${items.length} richieste`} in attesa di una scelta
      </p>
      {items.map((it, i) => (
        <div key={it.pending.id} data-testid={`home-pending-item-${i}`}>
          <p className="text-xs text-vg2-muted mb-2" data-testid={`home-pending-item-${i}-project`}>
            Progetto {it.has_results ? "già valutato" : "in corso"}: «{it.current_goal}» ·{" "}
            <Link to={`/vg2/${it.journey_id}`} className="underline" data-testid={`home-pending-item-${i}-open`}>apri il progetto</Link>
          </p>
          <PendingChoice journeyId={it.journey_id} pending={it.pending} hasResults={it.has_results}
                         tid={`home-pending-item-${i}-choice`} onDone={() => setTick((t) => t + 1)} />
        </div>
      ))}
    </div>
  );
}
